/**
@format
@flow
*/

import React from 'react';
import styled from 'styled-components';
import Colors from '@ziynx/theme/colors';
import { Heading } from '@ziynx/components/typography';
import { Button } from '@ziynx/components/buttons';

type Props = $ReadOnly<{|
  title?: string,
  button?: {
    inverted?: boolean,
    children?: string,
    width?: string,
  },
  onClick: () => void,

|}>;

const EmptyStateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const EmptyStateHeadingWrapper = styled.div`
  padding-bottom: 24px;
`;

const DiscoverEmptyState = (props: Props): React$Node => {
  const {
    title, button, onClick, ...rest
  } = props;

  return (
    <EmptyStateWrapper {...rest}>
      <EmptyStateHeadingWrapper>
        <Heading small color={Colors.Gray}>
          {!title ? 'No content from Talent to show' : title}
        </Heading>
      </EmptyStateHeadingWrapper>
      <Button
        variant="primary"
        inverted={button?.inverted || true}
        width="auto"
        onClick={onClick}
      >
        {!button?.children ? 'Reset Filter' : button?.children}
      </Button>
    </EmptyStateWrapper>
  );
};

export default DiscoverEmptyState;
